export default {
    updateUsers(state,payload){
        state.users = payload.data
        state.pagination.page = payload.current_page
        state.pagination.rowsPerPage = payload.per_page
        state.totalItems = payload.total
    },
}
